import { render } from "./VehiclesSlider.vue?vue&type=template&id=842e7d02&scoped=true"
import script from "./VehiclesSlider.vue?vue&type=script&lang=js"
export * from "./VehiclesSlider.vue?vue&type=script&lang=js"

import "./VehiclesSlider.vue?vue&type=style&index=0&id=842e7d02&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842e7d02"]])

export default __exports__